import logo from "./logo.svg";
import "./App.css";
import {
  getFirestore,
  collection,
  query,
  where,
  doc,
  setDoc,
  getDoc,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import {
  useCollection,
  useDocumentDataOnce,
} from "react-firebase-hooks/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import "bootstrap/dist/css/bootstrap.min.css";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Accordion from "react-bootstrap/Accordion";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Container from "react-bootstrap/Container";
import Offcanvas from "react-bootstrap/Offcanvas";
import ListGroup from "react-bootstrap/ListGroup";

// import * as moment from "moment";

import { useState, useEffect } from "react";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBBzepSPN2wdZfvan5GgyeeIREAV6k5BaU",
  authDomain: "loftie-4f472.firebaseapp.com",
  databaseURL: "https://loftie-4f472.firebaseio.com",
  projectId: "loftie-4f472",
  storageBucket: "loftie-4f472.appspot.com",
  messagingSenderId: "302939981606",
  appId: "1:302939981606:web:7fcb10ed6fe46fa437a3e7",
  measurementId: "G-L8VGQXX28P",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

const auth = getAuth(firebaseApp);

//

function UserSearch() {
  const [userSearch, setUserSearch] = useState("");
  const [email, setEmail] = useState("");
  const [userAuth, userLoading, userError] = useAuthState(auth);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search); // id=123
    const email = params.get("email"); // 123
    if (email) {
      setEmail(email);
      setUserSearch(email);
    }
  }, []);

  const findUser = (email) => {
    setEmail(email);
    window.history.pushState(null, null, `?email=${email}`);
  };

  return (
    <div>
      <Container>
        {userAuth ? (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              findUser(userSearch);
            }}
          >
            <br></br>
            <h5>Email search</h5>
            <InputGroup>
              <Form.Control
                type="email"
                value={userSearch}
                onChange={(e) => setUserSearch(e.target.value)}
                placeholder="name@email.com"
              />
              <Button variant="primary" type="submit">
                Search
              </Button>
            </InputGroup>
            <br></br>
            <div>{email && <UserDetails email={email} />}</div>
          </form>
        ) : (
          <>Auth Required</>
        )}
      </Container>
    </div>
  );
}

const UserDetails = ({ email }) => {
  const [user, setUser] = useState(null);
  const [showLoftiePlus, setShowLoftiePlus] = useState(false);
  const [addFreeMonths, setAddFreeMonths] = useState(false);
  const [addedLoftiePlusFreeMonths, setAddedLoftiePlusFreeMonths] = useState(0);
  const [loftiePlusFreeMonths, setLoftiePlusFreeMonths] = useState(0);

  const usersRef = collection(getFirestore(firebaseApp), "users");
  const [userRecords, loading, error] = useCollection(
    query(usersRef, where("email", "==", email || "")),
    {
      snapshotListenOptions: { includeMetadataChanges: true },
    }
  );

  const [config] = useCollection(
    query(collection(getFirestore(firebaseApp), "story-config"))
  );

  const [configData, setConfigData] = useState([]);
  // const [playlist, setPlaylist] = useState({});

  useEffect(() => {
    if (config) {
      setConfigData(config.docs[0].data());
    }
  }, [config]);

  useEffect(() => {
    if (userRecords?.docs[0]?.data()) {
      setUser({
        ...{ id: userRecords?.docs[0]?.id },
        ...userRecords?.docs[0]?.data(),
      });
      const userDocData = userRecords?.docs[0]?.data();
      setLoftiePlusFreeMonths(userDocData?.["freeLoftiePlusMonths"]);
    } else {
      setUser(null);
    }
  }, [userRecords]);

  const deleteStory = async (user, story) => {
    //move to global reference
    const userRef = doc(getFirestore(firebaseApp), "users", user.id);
    const confirmed = window.confirm(
      "Are you sure you want to delete this story?"
    );
    if (confirmed) {
      const userExistingStories = user?.stories || [];
      const newStories = userExistingStories.filter(
        (item) => item.id !== story.id
      );
      setDoc(userRef, { stories: newStories }, { merge: true });
    }
  };

  const [playlists, setPlaylists] = useState([]);
  useEffect(() => {
    if (configData?.default_playlist) {
      const defaultPlaylist = configData?.default_playlist;
      if (defaultPlaylist?.playlists) {
        const playlist = defaultPlaylist.playlists;
        setPlaylists(playlist);
      }
    }
  }, [configData]);

  // const handleResendTrack = (user, deprecatedTrack) =>{
  //   console.log("story", deprecatedTrack)
  //   let playlistObject =
  //   JSON.parse(JSON.stringify(configData?.default_playlist)) || [];
  //   console.log("playlist", playlistObject);
  //   let deprecatedPath;
  //   if (deprecatedTrack['Path']){
  //     deprecatedPath = deprecatedTrack['Path']
  //   }else{
  //     deprecatedPath = deprecatedTrack.path
  //   }
  //   console.log("path", deprecatedPath)

  //   //add user stories to playlist
  //   const userExistingStories = user?.stories || [];
  //     console.log("existing 1", userExistingStories);
  //     playlistObject?.playlists?.map((playlist)=>{
  //       if (playlist?.tracks?.length > 0){
  //         const track = playlist.tracks?.[0]
  //         if (track["Path"].indexOf("storymaker") > -1){
  //           userExistingStories.forEach((story)=>{
  //               playlist.tracks.push(
  //                 {
  //                   Name: story.title,
  //                   Path: story.path,
  //                   sName: story.title,
  //                   isEssential: 0
  //                 }
  //               )
  //           })
  //         }
  //         //find in the playlist the deprecated track, append reDownload
  //         const tracks = playlist.tracks
  //         tracks.forEach((track)=>{
  //           if (track["Path"]=== deprecatedPath){
  //             console.log("track", deprecatedPath)
  //             track["reDownload"] = 1
  //           }
  //         })
  //       }
  //     })

  //     const storyId = deprecatedTrack['id']

  //     const playlistId = Math.floor(Date.now() / 1000)
  //     playlistObject['id'] = playlistId

  //     //not all tracks have storyIds
  //     const updateDetails = {
  //       'event_type': 'send_track',
  //       'story_id' : null,
  //       'track_path': deprecatedPath
  //     }

  //     playlistObject['update_details'] = updateDetails
  //     //send to sendPlaylist function
  //     sendPlaylist(playlistObject, user)

  // }
  const handleResendTrack = (user, deprecatedTrack) => {
    let playlistObject =
      JSON.parse(JSON.stringify(configData?.default_playlist)) || [];

    let deprecatedPath = deprecatedTrack["Path"] || deprecatedTrack.path;

    const userExistingStories = user?.stories || [];

    playlistObject.playlists.forEach((playlist) => {
      if (playlist.Storymaker) {
        userExistingStories.forEach((story) => {
          playlist.Storymaker.push({
            Name: story.title,
            Path: story.path,
            sName: story.title,
            isEssential: 0,
          });
        });
      }

      // Find the deprecated track and append `reDownload`
      const tracks = playlist.Storymaker || [];
      tracks.forEach((track) => {
        if (track.Path === deprecatedPath) {
          track.reDownload = 1;
        }
      });
    });

    const playlistId = Math.floor(Date.now() / 1000);
    playlistObject.id = playlistId;

    const updateDetails = {
      event_type: "send_track",
      story_id: deprecatedTrack["id"] || null,
      track_path: deprecatedPath,
    };

    playlistObject.update_details = updateDetails;

    sendPlaylist(playlistObject, user);
  };

  const sendPlaylist = (playlistObject, user) => {
    user?.devices?.map(async (device) => {
      const deviceRef = doc(getFirestore(firebaseApp), "devices", device.id);
      const deviceSnap = await getDoc(deviceRef);
      const deviceVersion = deviceSnap?.data().state?.currentVer;
      if (configData.supported_versions.includes(deviceVersion)) {
        const deviceConfigRef = doc(
          getFirestore(firebaseApp),
          "device-details",
          device.id
        );

        setDoc(
          deviceConfigRef,
          { pending_playlist: playlistObject },
          { merge: true }
        );
        alert(`Playlist sent to Loftie ${device.id}`);
      } else {
        alert(`Playlist not sent to unsupported Loftie ${device.id}`);
      }
    });
  };
  const handleClose = () => setShowLoftiePlus(false);
  const handleShow = () => setShowLoftiePlus(true);
  const showMembershipInfo = (subject, value) => {
    return value ? (
      <ListGroup.Item>{`${subject} ${value}`}</ListGroup.Item>
    ) : null;
  };

  const formatMembershipInactiveDate = (subject, stringDate) => {
    let formattedDate = null;
    if (stringDate) {
      const [year, month, day] = stringDate.split("T")[0].split("-");
      formattedDate = `${month}-${day}-${year}`;
      return <ListGroup.Item>{`${subject} ${formattedDate}`}</ListGroup.Item>;
    }
  };
  const membershipInactiveDate = user?.["membership_inactive_date"]
    ? user?.["membership_inactive_date"]
    : null;

  formatMembershipInactiveDate(membershipInactiveDate);

  const determineSubscriptionContractStatus = async () => {
    const subscriptionRef = collection(
      getFirestore(firebaseApp),
      "subscription-contracts"
    );
    const q = query(subscriptionRef, where("user.email", "==", email));
    const querySnapshot = await getDocs(q);
    if (querySnapshot.size > 1) {
      return await handleMultipleSubscriptionDocs(querySnapshot);
    }
    if (querySnapshot.size == 0) {
      return await addFreeMonthsToUserDoc();
    }
    if (querySnapshot.size == 1) {
      const docSnapshot = querySnapshot.docs[0];
      const docData = docSnapshot.data();
      const membershipStatus = docData["status"];
      if (docData.status == "ACTIVE") {
        return await addFreeMonthsToSubscriptionDoc(docSnapshot.id);
      } else {
        return await addFreeMonthsToUserDoc();
      }
    }
  };

  const addFreeMonthsToSubscriptionDoc = async (contractDocId) => {
    await updateDoc(
      doc(getFirestore(firebaseApp), "subscription-contracts", contractDocId),
      { free_months_remaining: parseInt(addedLoftiePlusFreeMonths, 10) }
    );
    await updateDoc(doc(usersRef, user.id), {
      freeLoftiePlusMonths: parseInt(addedLoftiePlusFreeMonths, 10),
    });
  };

  const addFreeMonthsToUserDoc = async () => {
    const date = new Date();
    date.setMonth(date.getMonth() + parseInt(addedLoftiePlusFreeMonths, 10));
    await updateDoc(doc(usersRef, user.id), {
      freeLoftiePlusMonths: parseInt(addedLoftiePlusFreeMonths, 10),
      membership_inactive_date: date.toISOString(),
      membership_status: "CANCELLED",
      "loftie-plus-membership": true,
    });
  };

  const handleMultipleSubscriptionDocs = async (docs) => {
    let hasActiveContract = false;
    docs.forEach((doc) => {
      const docData = doc.data();
      if (docData.status == "ACTIVE") {
        hasActiveContract = true;
        return addFreeMonthsToSubscriptionDoc(doc.id);
      }
    });
    if (!hasActiveContract) {
      return await addFreeMonthsToUserDoc();
    }
  };

  const handleAddFreeLoftiePlusMonths = async () => {
    if (!user?.["loftie-plus-membership"]) {
      return await addFreeMonthsToUserDoc();
    } else {
      return await determineSubscriptionContractStatus();
    }
  };

  return (
    <>
      {user ? (
        <>
          <p>{user.email}</p>
          <p>User id: {user.id}</p>
          <p>App version: {user.appVersion}</p>
          <p>
            <Button variant="outline-info" onClick={handleShow}>
              Loftie Plus: {user?.["loftie-plus-membership"] ? "True" : "False"}
            </Button>
          </p>
          <Offcanvas show={showLoftiePlus} onHide={handleClose}>
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Loftie Plus Membership</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <ListGroup>
                <ListGroup.Item>
                  Loftie Plus:{" "}
                  {user?.["loftie-plus-membership"] ? "True" : "False"}
                </ListGroup.Item>
                {showMembershipInfo(
                  "Membership Type:",
                  user?.["membership_type"]
                )}
                {formatMembershipInactiveDate(
                  "Date Membership Bought:",
                  user?.["created_at"]
                )}
                {showMembershipInfo(
                  "Membership Status:",
                  user?.["membership_status"]
                )}
                {formatMembershipInactiveDate(
                  "Membership Inactive Date:",
                  user?.["membership_inactive_date"]
                )}
                {showMembershipInfo("Free Months Given:", loftiePlusFreeMonths)}
                {showMembershipInfo("Membership Type:", user?.["type"])}
                {/* {user?.['subscription_id'] ? <ListGroup.Item>{"Shopify Subscription Page:"}</ListGroup.Item> : null} */}
                {user?.["subscription_id"] ? (
                  <ListGroup.Item>
                    <a
                      href={`https://admin.shopify.com/store/byloftie/apps/subscription-app-113/app/contract/${user["subscription_id"]}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Shopify Subscription Page
                    </a>
                  </ListGroup.Item>
                ) : null}
              </ListGroup>
              <Spacer height={15}></Spacer>
              <Button
                variant="outline-info"
                onClick={() => setAddFreeMonths(!addFreeMonths)}
              >
                Add Free Loftie+ Months
              </Button>
              {addFreeMonths && (
                <Form
                  className="mt-3"
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleAddFreeLoftiePlusMonths();
                  }}
                >
                  <InputGroup>
                    <Form.Control
                      type="number"
                      placeholder="Enter number of months"
                      value={addedLoftiePlusFreeMonths}
                      onChange={(e) =>
                        setAddedLoftiePlusFreeMonths(e.target.value)
                      }
                      min="1"
                    />
                    <Button type="submit" variant="info">
                      Submit
                    </Button>
                  </InputGroup>
                </Form>
              )}

              <Spacer height={20}></Spacer>
              <ListGroup>
                <ListGroup.Item className="text-muted" style={{ fontSize: "0.85em" }}>
                  Granting Lifetime Loftie+ for a gift that landed on the wrong
                  address is done from{" "}
                  <a href="/subscriptionContracts">Subscription Contracts</a> —
                  the grant lives on the contract, which is not searchable by the
                  creator's own email until it has been reassigned. Look it up by
                  order number.
                </ListGroup.Item>
              </ListGroup>
            </Offcanvas.Body>
          </Offcanvas>

          <h6>Lofties</h6>
          {/* {JSON.stringify(user)} */}
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>id</th>
                <th>type</th>
                <th>FW version</th>
                <th>Online Status</th>
                <th>Links</th>
              </tr>
            </thead>
            <tbody>
              {user?.devices?.map((device) => (
                <LoftieInfo loftieId={device.id} user={user} />
              ))}
            </tbody>
          </Table>
          {user?.stories?.length > 0 ? (
            <>
              <h9>Stories</h9>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    {/* <th>id</th> */}
                    <th>title</th>
                    <th>path</th>
                    <th>play</th>
                    <th>delete</th>
                    <th>send</th>
                  </tr>
                </thead>
                <tbody>
                  {user?.stories?.map((story) => (
                    <tr key={story.id}>
                      {/* <td>{story.id}</td> */}
                      <td>
                        <a href={`/?id=${story.id}`} target="_blank">
                          {story.title}
                        </a>
                      </td>
                      <td>
                        <a
                          href={`https://fwbek2lb0a213kbewqoit.byloftie.com/sdcard/${story.path}`}
                        >
                          {story.path}
                        </a>
                      </td>
                      <td>
                        <audio
                          controls
                          src={`https://fwbek2lb0a213kbewqoit.byloftie.com/sdcard/${story.path}`}
                        />
                      </td>
                      <td>
                        <FontAwesomeIcon
                          onClick={() => deleteStory(user, story)}
                          style={{ cursor: "pointer" }}
                          icon={faTrash}
                        />
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          onClick={() => handleResendTrack(user, story)}
                        >
                          send
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {/* <DefaultPlaylist playlists={playlists}/> */}
            </>
          ) : (
            <p>No stories yet</p>
          )}
          <PlaylistTracks
            handleResendTrack={handleResendTrack}
            playlists={playlists}
            user={user}
          />
        </>
      ) : (
        <>No user found</>
      )}
    </>
  );
};

const LoftieInfo = ({ loftieId, user }) => {
  const [snapshot, loading, error, reload] = useDocumentDataOnce(
    doc(getFirestore(firebaseApp), "devices", loftieId)
  );
  return (
    <tr key={loftieId}>
      <td> {loftieId}</td>
      <td>
        {snapshot?.state?.currentVer?.toLowerCase().includes("lamp")
          ? "Lamp"
          : "Clock"}
      </td>
      <td>{snapshot?.state?.currentVer}</td>
      <td>{snapshot?.connection?.status || "offline"}</td>
      <td>
        <a href={`/loftie?id=${loftieId}`} target="_blank">
          device details
        </a>
      </td>
    </tr>
  );
};
const PlaylistTracks = ({ playlists, handleResendTrack, user }) => {
  const filteredPlaylists = playlists.filter((playlist) =>
    Object.values(playlist).some(
      (categoryTracks) =>
        Array.isArray(categoryTracks) &&
        categoryTracks.some((track) => track.sName !== "NA")
    )
  );

  return (
    <div>
      <Accordion>
        {filteredPlaylists.map((playlist, playlistIndex) =>
          Object.entries(playlist).map(([categoryName, tracks]) => (
            <Accordion.Item
              eventKey={`${playlistIndex}-${categoryName}`}
              key={`${playlistIndex}-${categoryName}`}
            >
              <Accordion.Header>{categoryName}</Accordion.Header>
              <Accordion.Body>
                <Table striped>
                  <thead>
                    <tr>
                      <th>Track</th>
                      <th>Send</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(tracks) && tracks.length > 0 ? (
                      tracks.map((track, trackIndex) => (
                        <tr key={trackIndex}>
                          <td>{track.sName}</td>
                          <td>
                            <Button
                              variant="outline-primary"
                              onClick={() => handleResendTrack(user, track)}
                            >
                              Resend
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="2">No tracks available</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Accordion.Body>
            </Accordion.Item>
          ))
        )}
      </Accordion>
      <br />
    </div>
  );
};

const Spacer = ({ width, height }) => {
  return <div style={{ width: width || 1, height: height || 1 }}></div>;
};

export default UserSearch;
